<template>
    <div>
        <report-header
            :title="title"
            :isLoading="isLoading"
            :reportPagination="pagination"
            :isShowDateRange="true"
            :formatDateRangeTitle="dateRange"
        />
        <b-card id="report-card">
            <div id="report-body" class="w-100">
                <div v-if="isInitialLoad" class="w-100 pt-2 pb-2">
                    <i
                        >Please select the
                        <a @click="openFilterModal" class="text-link">filter</a>
                    </i>
                </div>
                <template v-else>
                    <div>
                        <p class="item-name">
                            SUMMARY
                        </p>
                        <QTable
                            v-if="summaryData.length == 0"
                            :columns="summaryHeader"
                            :data="[]"
                            hide-bottom
                            :loading="isLoading"
                            :rows-per-page-options="[0]"
                        >
                            <template v-slot:bottom-row>
                                <q-tr v-if="isLoading">
                                    <q-td colspan="8">Loading summary...</q-td>
                                </q-tr>
                                <q-tr
                                    v-else-if="
                                        !isLoading && !isInitialLoad && !isError
                                    "
                                >
                                    <q-td colspan="8"
                                        >No records available</q-td
                                    >
                                </q-tr>
                            </template>
                        </QTable>
                        <template v-else>
                            <table
                                id="table-provider"
                                class="w-100 table-responsive"
                            >
                                <thead>
                                    <tr>
                                        <th
                                            v-for="header in summaryHeader"
                                            :key="header.name"
                                            :style="header.style"
                                            class="th-class text-capitalize"
                                            :class="header.classes"
                                        >
                                            <strong
                                                v-if="header.isProvider"
                                                class="text-link"
                                                @click="scrollToDiv(header)"
                                                >{{ header.label }}
                                            </strong>
                                            <strong v-else
                                                >{{ header.label }}
                                            </strong>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(sdata, index) in summaryData"
                                        :key="index"
                                    >
                                        <td
                                            v-for="header in summaryHeader"
                                            :key="`${summaryData.category}-${header.name}`"
                                            :class="[
                                                header.classes,
                                                sdata.classes
                                            ]"
                                            :style="header.style"
                                        >
                                            {{
                                                displaySummaryData(
                                                    sdata,
                                                    header
                                                )
                                            }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </template>
                    </div>
                    <QTable
                        v-if="resultProviders.length == 0"
                        :columns="headerProviders"
                        :data="[]"
                        hide-bottom
                        :loading="isLoading"
                        :rows-per-page-options="[0]"
                    >
                        <template v-slot:bottom-row>
                            <q-tr v-if="isLoading">
                                <q-td colspan="8"
                                    >Loading payments...
                                    {{ dataLoadedString }}</q-td
                                >
                            </q-tr>
                            <q-tr
                                v-else-if="
                                    !isLoading && !isInitialLoad && !isError
                                "
                            >
                                <q-td colspan="8">No records available</q-td>
                            </q-tr>
                        </template>
                    </QTable>
                    <template v-else>
                        <div
                            v-for="(provider, index) in resultProviders"
                            :key="index"
                            :id="'table_' + index"
                        >
                            <div :id="`${provider.providerId}`" class="pr-2">
                                <p class="item-name">
                                    {{ provider.name }}
                                    <small>{{
                                        getResultText(provider.data.length)
                                    }}</small>
                                </p>
                            </div>
                            <table
                                id="table-provider"
                                class="w-100 table-responsive table-hover"
                            >
                                <thead>
                                    <tr>
                                        <th
                                            v-for="header in headerProviders"
                                            :key="header.name"
                                            :style="header.style"
                                            class="th-class"
                                            :class="header.classes"
                                        >
                                            {{ header.label }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(pdata, index) in provider.data"
                                        :key="index"
                                    >
                                        <td class="text-center">
                                            {{
                                                formatDate(
                                                    parseInt(
                                                        pdata.applied_date_raw
                                                    )
                                                )
                                            }}
                                        </td>
                                        <td class="text-left">
                                            {{ pdata["Payment"] }}
                                        </td>
                                        <td class="text-left">
                                            {{
                                                formatDate(parseInt(pdata.date))
                                            }}
                                        </td>
                                        <td
                                            class="text-capitalize text-break text-left"
                                        >
                                            {{
                                                decodeItemName(pdata.item_name)
                                            }}
                                        </td>
                                        <td
                                            class="text-capitalize text-break text-left"
                                        >
                                            {{ categoryString(pdata) }}
                                        </td>
                                        <td class="text-center">
                                            <a
                                                v-if="pdata['inv_id']"
                                                :href="
                                                    generateInvoiceUrl(
                                                        pdata['inv_id']
                                                    )
                                                "
                                                @click="
                                                    navigateToInvoice(
                                                        $event,
                                                        pdata['inv_id']
                                                    )
                                                "
                                            >
                                                {{ invoiceString(pdata) }}
                                            </a>
                                            <span v-else>{{
                                                invoiceString(pdata)
                                            }}</span>
                                        </td>
                                        <td class="text-center">
                                            {{
                                                _toCurrency(
                                                    Number(
                                                        pdata.item_billed_amount
                                                    )
                                                )
                                            }}
                                        </td>
                                        <td class="text-center">
                                            {{
                                                _toCurrency(
                                                    pdata.weighted_amount
                                                )
                                            }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </template>
                </template>
            </div>
        </b-card>
    </div>
</template>

<script>
import { QTable } from "quasar";
import Report from "@/mixins/report.js";
import ReportService from "@/services/report";
import CREPORT from "@/constants/report";
import "@/css/quasar-table.css";
import { forEach, isEmpty } from "lodash";

const entities = require("entities");
const initialSummaryHeader = [
    {
        name: "category",
        label: "Category (Type)",
        field: "category",
        classes: "text-left",
        style: "width: 9%;"
    },
    {
        name: "total",
        label: "Total",
        field: "Total",
        classes: "text-center",
        style: "width: 7%"
    }
];
export default {
    mixins: [Report],
    components: {
        QTable,
        ReportHeader: () => import("@/components/report/report-header")
    },
    props: {
        data: {
            type: Object,
            default() {
                return {
                    start: this.getStartDate("month"),
                    end: this.getEndDate("day")
                };
            }
        }
    },
    data() {
        return {
            resultProviders: [],
            title: "Payment By Provider",
            dateRange: "",
            isInitialLoad: true,
            isLoading: false,
            isError: false,
            indexAxios: 0,
            abortController: [],
            summaryHeader: initialSummaryHeader,
            summaryData: [],
            totalResultProvidersData: 0
        };
    },
    mounted() {
        let self = this;
        self.data.reportId = CREPORT.TYPE.PAYMENT_BY_PROVIDER;
        self.data.filterDateOption = true;
        self.data.isShowProvider = false;
        self.data.isShowDateRange = true;
        self.data.datePickerOptionDefault = 3;

        self._getSetting().then(() => {
            self.data.start = self.getStartDate("month");
            self.data.end = self.getEndDate("day");
            self.data.from = self.converToUnix(self.data.start);
            self.data.to = self.converToUnix(self.data.end);
            self.togglehideActions(true);
            self.openFilterModal();
            // self.init(self.indexAxios);
        });

        self.$root.$on("report-filter-date-range:refresh", self.prepareData);
        self.$root.$on("payment-by-provider:refresh", function () {
            if (self.abortController.length > 0) {
                self.abortController[self.indexAxios].abort();
            }
            self.indexAxios++;
            self.resultProviders = [];
            self.summaryData = [];
            self.togglehideActions(true);
            self.resetPagination();
            self.init(self.indexAxios, 1);
        });
        window.scrollTo(0, 0);
    },
    beforeDestroy: function () {
        this.data.isShowDateTimeRange = false;
        this.data.datePickerOptionDefault = null;
        this.data.reportId = null;
        this.$root.$off("report-filter-date-range:refresh", this.prepareData);
        this.$root.$off("payment-by-provider:refresh");
        if (this.abortController.length > 0) {
            this.abortController[this.indexAxios].abort();
        }
    },
    methods: {
        generateInvoiceUrl(invoiceEncodedId) {
            return `${window.location.origin}/view/billing/invoice/${invoiceEncodedId}`;
        },
        navigateToInvoice(event, invoiceEncodedId) {
            if (!event.ctrlKey && !event.metaKey && !event.shiftKey) {
                event.preventDefault();
                this.$router.push({
                    name: "invoice",
                    params: { id: invoiceEncodedId }
                });
            }
        },
        displaySummaryData(sdata, header) {
            if (header.name === "category") {
                return this.removeBracket(sdata[header.name]);
            } else if (header.name === "total") {
                return this.removeBracket(sdata["Total"]);
            }
            return sdata[header.name] || this._toCurrency(0);
        },
        categoryString(pdata) {
            const itemTypeString = pdata.item_type
                ? `(${pdata.item_type})`
                : "";
            return `${pdata.category} ${itemTypeString}`;
        },
        invoiceString(pdata) {
            return `Invoice #${pdata["invoice_index"]}`;
        },
        handleError(indexAxios, error) {
            if (!this.abortController[indexAxios].signal.aborted) {
                console.error(error.message);
                this.isLoading = false;
                this.loadingCompleted();
                this.togglehideActions(false);
                this.isError = true;
                this._message("Error: Unable to get the report", "danger");
            }
        },
        scrollToDiv(provider) {
            const element = document.getElementById(provider.providerId);
            if (element) {
                element.scrollIntoView({ behavior: "smooth" });
            }
        },
        getResultText(length) {
            const resultString = length > 1 ? "results" : "result";
            return `- ${length} ${resultString}`;
        },
        formatDate(value) {
            return value
                ? this._toDateTime(parseInt(value)).toFormat(this._dateFormat)
                : "";
        },
        prepareData(params) {
            if (this.abortController.length > 0) {
                this.abortController[this.indexAxios].abort();
            }
            if (params) {
                this.data.from = params.from;
                this.data.to = params.to;
            }
            this.indexAxios++;
            this.resultProviders = [];
            this.summaryData = [];
            this.togglehideActions(true);
            this.resetPagination();
            this.init(this.indexAxios);
        },
        async init(indexAxios, isRefresh = 0) {
            let self = this;
            self.isLoading = true;
            self.isError = false;
            self.isInitialLoad = false;

            self.pagination.page = 1;
            self.abortController[indexAxios] = new AbortController();
            self.resultProviders = [];
            self.summaryHeader = initialSummaryHeader;
            self.summaryData = [];
            self.dateRange = self.getDateRange(self.data.from, self.data.to);
            self.loadingPercentages();
            await ReportService.getReport(CREPORT.TYPE.PAYMENT_BY_PROVIDER, {
                from: self.data.from,
                to: self.data.to,
                signal: self.abortController[indexAxios].signal,
                show_results: false,
                refresh: isRefresh
            })
                .then(res => {
                    if (res && res.message && res.message.code === 200) {
                        self.dateRange = self.getDateRange(
                            res.resource.results.from,
                            res.resource.results.to
                        );
                        if (
                            !isEmpty(
                                res.resource.results.summary_detail.summary
                            )
                        ) {
                            self.generateResultSummary(
                                res.resource.results.summary_detail
                            );
                            self.getProviderDetails(indexAxios);
                        } else {
                            self.loadingCompleted();
                            self.timer(1000).then(() => {
                                self.togglehideActions(false);
                                self.isLoading = false;
                            });
                        }
                    } else {
                        throw new Error("Error: Unable to get the report.");
                    }
                })
                .catch(e => {
                    self.handleError(indexAxios, e);
                })
                .finally(() => {
                    self.dynamicPageTitle(self.title);
                });
        },
        async getProviderDetails(indexAxios) {
            let self = this;
            let tempProviders = [];
            self.pagination.page = 1;
            self.pagination.lastPage = 1; // Last page will be updated in first API

            while (self.pagination.page <= self.pagination.lastPage) {
                self.loadingPercentages();
                try {
                    let res = await ReportService.getReport(
                        CREPORT.TYPE.PAYMENT_BY_PROVIDER,
                        {
                            from: self.data.from,
                            to: self.data.to,
                            page: self.pagination.page,
                            perPage: 50,
                            signal: self.abortController[indexAxios].signal,
                            show_results: true
                        }
                    );

                    if (res && res.message && res.message.code === 200) {
                        tempProviders.push(
                            ...res.resource.results.query_results.data
                        );

                        // Update the pagination last page
                        if (self.pagination.page === 1) {
                            self.pagination.lastPage =
                                res.resource.results.query_results.meta.lastPage;
                            self.totalResultProvidersData =
                                res.resource.results.query_results.meta.total;
                        }
                        self.totalDataLoaded =
                            res.resource.results.query_results.meta.to;
                    } else {
                        throw new Error("Error: Unable to get the report.");
                    }
                    self.pagination.page++;
                } catch (e) {
                    this.handleError(indexAxios, e);
                    break;
                }
            }

            // After all pages are fetched, pass all data to the generateResultProviders function
            self.generateResultProviders(tempProviders);
            self.loadingCompleted();
            self.timer(1000).then(() => {
                self.togglehideActions(false);
                self.isLoading = false;
            });
        },
        generateResultSummary(summaryDetails) {
            const idleCallback =
                window.requestIdleCallback ||
                function (cb) {
                    setTimeout(cb, 50);
                };

            idleCallback(() => {
                let summaryHeader = [
                    {
                        name: "category",
                        label: "Category (Type)",
                        field: "category",
                        align: "left",
                        classes: "text-left",
                        style: "width: 9%;",
                        format: val => {
                            return this.removeBracket(val);
                        }
                    }
                ];

                if (
                    summaryDetails.provider &&
                    !isEmpty(summaryDetails.provider)
                ) {
                    forEach(
                        Object.values(summaryDetails.provider),
                        providerName => {
                            const providerId = providerName.replace(/\s/g, "");
                            summaryHeader.push({
                                isProvider: true,
                                providerId,
                                name: providerName,
                                label: providerName,
                                align: "center",
                                classes: "text-center",
                                style: "width: 7%",
                                field: providerName,
                                format: val => {
                                    return val ? val : this._toCurrency(0);
                                }
                            });
                        }
                    );
                }

                summaryHeader.push({
                    name: "total",
                    label: "Total",
                    field: "Total",
                    align: "center",
                    style: "width: 7%",
                    classes: "font-weight-bold text-center"
                });

                this.summaryHeader = summaryHeader;

                if (
                    summaryDetails.summary &&
                    !isEmpty(summaryDetails.summary)
                ) {
                    // For the provider data
                    let summaryData = Object.entries(summaryDetails.summary)
                        .map(([category, value]) => ({ category, ...value }))
                        .sort((a, b) => a.category.localeCompare(b.category));

                    // For total at the bottom
                    summaryDetails.provider_total.category = "Total";
                    summaryDetails.provider_total.classes = "font-weight-bold";
                    summaryData.push(summaryDetails.provider_total);

                    this.summaryData = summaryData;
                }
            });
        },
        generateResultProviders(queryResults) {
            const providerMap = new Map();

            this.resultProviders.forEach(provider => {
                providerMap.set(provider.name, provider);
            });

            queryResults.forEach(result => {
                let doctorObject = providerMap.get(result.doctor_name);
                const providerId = result.doctor_name.replace(/\s/g, "");

                if (!doctorObject) {
                    doctorObject = {
                        name: result.doctor_name,
                        data: [result],
                        isExpand: false,
                        providerId
                    };
                    providerMap.set(result.doctor_name, doctorObject);
                } else {
                    doctorObject.data.push(result);
                }
            });
            this.resultProviders = Array.from(providerMap.values());
        },
        togglehideActions(value) {
            this.defaultToggleHideActions(value);
        },
        removeBracket(name) {
            return name.replace("()", "");
        },
        decodeItemName(name) {
            return entities.decodeHTML(name);
        }
    },
    computed: {
        dataLoadedString() {
            return `(${this.pagination.current}%)`;
        },
        headerProviders() {
            return [
                {
                    name: "paid",
                    label: "Paid",
                    style: "width:9%;min-width:115px",
                    classes: "text-center"
                },
                {
                    name: "payment",
                    label: "Payment",
                    style: "width:11%",
                    classes: "text-left"
                },
                {
                    name: "date",
                    label: "Item Date",
                    style: "width: 9%;min-width:115px",
                    classes: "text-left"
                },
                {
                    name: "item_name",
                    label: "Item",
                    style: "width: 22%;min-width:150px",
                    classes: "text-left"
                },
                {
                    name: "category_item_type",
                    label: "Category",
                    style: "width: 22%;min-width:150px",
                    classes: "text-left"
                },
                {
                    name: "invoice",
                    label: "Invoice",
                    style: "width: 9%",
                    classes: "text-center"
                },
                {
                    name: "item_billed_amount",
                    label: "Billed",
                    style: "width: 9%",
                    classes: "text-center"
                },
                {
                    name: "weighted_amount",
                    label: "Applied",
                    style: "width: 9%",
                    classes: "text-center"
                }
            ];
        }
    }
};
</script>

<style scoped>
#table-provider td,
#table-provider th {
    padding: 7px 16px;
}
#table-provider tr {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
#table-provider th {
    font-size: medium;
    border-top: 1px solid #c6c6c6;
}
</style>
